import { useDeepResearch } from "../useDeepResearch";
import DeepResearchChatStatus from "./DeepResearchChatStatus";
import { useChatStatusSessions } from "./useChatStatusSessions";
import { useFeatureFlag } from "@app/hooks/useFeatureFlag";
import { Stack } from "@mantine/core";

/**
 * DeepResearchChatStatus wired to an experiment's runs, newest first. Renders nothing when there
 * is no run to show, so the chat can mount it unconditionally.
 */
export default function ExperimentDeepResearchChatStatus({
  experimentId,
  isDraft
}: {
  experimentId: string;
  isDraft: boolean;
}) {
  const isDeepResearchEnabled = useFeatureFlag("deep-research");
  const { sessions, dismiss } = useChatStatusSessions(experimentId, isDeepResearchEnabled);
  const { cancelSession, cancelMutation } = useDeepResearch();

  if (sessions.length === 0) {
    return null;
  }

  const basePath = isDraft ? `/experiments/drafts/${experimentId}` : `/experiments/${experimentId}`;

  return (
    <Stack gap={5} mb={5}>
      {sessions.map(session => (
        <DeepResearchChatStatus
          key={session.id}
          session={session}
          // report_id is set only once the run succeeded; without one, fall back to the research tab.
          detailsTo={session.report_id ? `${basePath}/research/${session.report_id}` : `${basePath}/research`}
          onDetailsClick={() => dismiss(session.id)}
          onCancel={() => cancelSession(session.id)}
          isCancelling={cancelMutation.isPending}
        />
      ))}
    </Stack>
  );
}
